export default __webpack_public_path__ + "static/climate-environmental-justice-accomplishment-1-0d22f90f78105dd5c8a2096a6753a035.webp";